<div class="po-field-container-bottom">
    <span class="po-field-container-bottom-text-error"> 
        <span class="po-icon po-icon-warning po-field-container-icon-error"></span>
         {{text}}
    </span>  
</div>
